/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseInfo } from './ResponseInfo';
import {
    ResponseInfoFromJSON,
    ResponseInfoFromJSONTyped,
    ResponseInfoToJSON,
} from './ResponseInfo';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface LogEntry
 */
export interface LogEntry {
    /**
     * 
     * @type {Array<string>}
     * @memberof LogEntry
     */
    details?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    locationHref?: string;
    /**
     * 
     * @type {ResponseInfo}
     * @memberof LogEntry
     */
    responseInfo?: ResponseInfo;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    stackTrace?: string;
    /**
     * 
     * @type {User}
     * @memberof LogEntry
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    userAgent?: string;
}

/**
 * Check if a given object implements the LogEntry interface.
 */
export function instanceOfLogEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LogEntryFromJSON(json: any): LogEntry {
    return LogEntryFromJSONTyped(json, false);
}

export function LogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': !exists(json, 'details') ? undefined : json['details'],
        'locationHref': !exists(json, 'locationHref') ? undefined : json['locationHref'],
        'responseInfo': !exists(json, 'responseInfo') ? undefined : ResponseInfoFromJSON(json['responseInfo']),
        'stackTrace': !exists(json, 'stackTrace') ? undefined : json['stackTrace'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
    };
}

export function LogEntryToJSON(value?: LogEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'locationHref': value.locationHref,
        'responseInfo': ResponseInfoToJSON(value.responseInfo),
        'stackTrace': value.stackTrace,
        'user': UserToJSON(value.user),
        'userAgent': value.userAgent,
    };
}

